interface StoreWithSetters {
    getRawData: () => any;
    setData: (value: any) => void;
}
type RootStore = Record<string, StoreWithSetters | Record<string, any>>;

type Payload<T extends RootStore> = Partial<{
    [K in keyof T]: T[K] extends StoreWithSetters
        ? Parameters<T[K]['setData']>[0] | ((payload: ReturnType<T[K]['getRawData']>) => Parameters<T[K]['setData']>[0])
        : never;
}>;

export const createSetData =
    <T extends RootStore>(rootStore: T) =>
    (payload: Payload<T>) => {
        Object.entries(payload).forEach(([key, valueOrCallback]) => {
            const store = rootStore[key];

            if (typeof store.setData !== 'function' || valueOrCallback === undefined) {
                return;
            }

            if (typeof valueOrCallback === 'function') {
                const prevData = store.getRawData();
                store.setData(valueOrCallback(prevData));
                return;
            }

            store.setData(valueOrCallback);
        });
    };
